import PropTypes from 'prop-types';
import ProgressRing from './ProgressRing';
import css from './ProgressRing.scss';

const classes = {
    root: css.progressRing,
};

ProgressRing.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.objectOf(PropTypes.string),
    radius: PropTypes.number,
	stroke: PropTypes.number,
	progress: PropTypes.number,
};

ProgressRing.defaultProps = {
    className: '',
    classes,
    radius: 100,
	stroke: 10,
	progress: 100,
};

ProgressRing.displayName = 'ProgressRing';
export { ProgressRing };
export default ProgressRing;
